module.exports = __webpack_public_path__ + "static/media/FullSizeRender-min.4f46b3fe.jpg";